import { useTranslation } from 'react-i18next'
import Badge, { type BadgeTone } from '../../../components/ui/Badge'
import { responseKey, type AgendaResponse } from '../types'

/** Yanıt → rozet tonu: bekleniyor mavi, katılacak yeşil, katılmayacak kırmızı. */
const TONE: Record<AgendaResponse, BadgeTone> = {
  PENDING: 'blue',
  ATTENDING: 'green',
  NOT_ATTENDING: 'red',
}

/** Katılım yanıtı rozeti (yanıt REFERANS kimliği değil metin enum'u → `StatusTag` değil `Badge`). */
export default function ResponseBadge({ response }: Readonly<{ response: AgendaResponse }>) {
  const { t } = useTranslation()
  return (
    <Badge tone={TONE[response] ?? 'blue'} variant="soft">
      {t(responseKey(response))}
    </Badge>
  )
}
